var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockOpen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 4C18.5 4 14 8.5 14 14V18H18V14C18 10.7 20.7 8 24 8C27.3 8 30 8.2 30 11.5H33C33 6 29.5 4 24 4Z",
    fill: "#424242"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36 44H12C9.8 44 8 42.2 8 40V22C8 19.8 9.8 18 12 18H36C38.2 18 40 19.8 40 22V40C40 42.2 38.2 44 36 44Z",
    fill: "#EE8003"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 28C23.2044 28 22.4413 28.3161 21.8787 28.8787C21.3161 29.4413 21 30.2044 21 31C21 31.7956 21.3161 32.5587 21.8787 33.1213C22.4413 33.6839 23.2044 34 24 34C24.7956 34 25.5587 33.6839 26.1213 33.1213C26.6839 32.5587 27 31.7956 27 31C27 30.2044 26.6839 29.4413 26.1213 28.8787C25.5587 28.3161 24.7956 28 24 28Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOpen);
export default __webpack_public_path__ + "static/media/lock-open.2d62121e8e613b9d39d02e138ab3e8f8.svg";
export { ForwardRef as ReactComponent };